mainApp.directive('singleRange', function() {
    return {
        templateUrl: '/public/directives/singleRange.html'
    }
});